// Send Email confirmation
export const PREREGISTATION_API = "/api/v2/registration/pre-register";
export type PreregistrationRequest = {
  picEmail: string;
  timeZone: string;
};
export type PreregistrationResponse = {
  status: "OK" | "EMAIL_HAS_REGISTERED";
};
